import $ from "jquery";
import swiperSlider from "../swiperSlider/swiperSlider";

const recentblogs = {
    variable:{
        url: window.location.href,
    },
    methods: {
        addSwiper: (element) => {
            let config = {
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 16,
                    },
                    768: {
                        slidesPerView: 2.5,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                },
                // slides are <a> links: swiper's role="group" is not allowed on them and its
                // "1 / 10" aria-label would replace the link's own name
                a11y: {
                    slideRole: null,
                    slideLabelMessage: null,
                },
            };
            $(element).find(".recent-blogs__swiper-box--swiper") &&
                swiperSlider.methods.initializerSwiper(
                    $(element).find(".recent-blogs__swiper-box--swiper").get(0),
                    config
                );
        },
        init: () => {
            $(".recent-blogs").each((idx, ele) => {
                recentblogs.methods.addSwiper(ele);
            });
            $(".recent-blogs__swiper-wrapper--slide").on('click', function(e){
               if($(e.target).hasClass('recent-blogs__cta')){
                    let buttonText=e.target.innerText.replace(/\n/g, '').trim();
                    let articleName = $(e.currentTarget).find('.recent-blogs__title').text().replace(/\n/g, '').trim();
                    let obj = recentblogs.methods.dataLayerObj(e, buttonText, articleName);
                    createDataLayer('buttonClick', obj);
               }else{
                    let articleName = e.currentTarget.getElementsByClassName("recent-blogs__title")[0].innerText.replace(/\n/g, '').trim();
                    let buttonText=e.currentTarget.getElementsByClassName("recent-blogs__title")[0].innerText.replace(/\n/g, '').trim();
                    let obj = recentblogs.methods.dataLayerObj(e, buttonText, articleName);
                    createDataLayer('buttonClick', obj);
               }
            });
        },
        viewAllClickHandler : function () {
                      $(document).on('click', '.chli_btn', function(e) {
                            if ($(this).closest('.recent-blogs__button').length) {
                                        var obj = recentblogs.methods.dataLayerObj(e);
                                        createDataLayer('buttonClick', obj);
                                    }
                    });
                    $('.recent-blogs__button--prev').on('click', function(e) {
                        let  buttonText="Previous";
                        var obj = recentblogs.methods.dataLayerObj(e, buttonText);
                        createDataLayer('List_Scroll_Previous', obj);
                    });
                    $('.recent-blogs__button--next').on('click', function(e) {
                        let  buttonText="Next";
                        var obj = recentblogs.methods.dataLayerObj(e, buttonText);
                        createDataLayer('List_Scroll_Next', obj);
                    });
        },

        dataLayerObj : function(e, buttonText , articleName){
            let titleText = '';
            const $recentBlogs = $(e.target).closest('.recentblogs');
            const $genericContainer = $recentBlogs.closest('.genericContainer');
            const $chliTitle = $genericContainer.prev('.chlititle');
            if ($chliTitle.length > 0) {
                titleText = $chliTitle.find('h2').text();
            }
            else {
                titleText = 'Recent Blogs';
            }
            var obj = {
                'articleName' : articleName ? articleName : '',
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : buttonText ? buttonText : "Read More",
                'pageSection' : titleText,
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? recentblogs.variable.url.includes("blog") ? "Blogs" : recentblogs.variable.url.substring(recentblogs.variable.url.indexOf(".com/"), recentblogs.variable.url.lastIndexOf('/')  === ".com") && !recentblogs.variable.url.substring(recentblogs.variable.url.indexOf(".com/"), recentblogs.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : "",
                'productName' : "",
                'question' : "",
                'source' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'bannerName' : "",

            };
            return obj;
        },
    },
};

$(() => {
    if($(".recent-blogs").length)
    {
        recentblogs.methods.init();
        recentblogs.methods.viewAllClickHandler();
    }
});

